export function BooleanValue(input: any) {
  return input == 'true' || input == '1' ? true : input == 'false' || input == '0' ? false : null
}

export { BooleanValue as Boolean }
